import apiClient from './client';

// Fuel types: object like { car_petrol: "Autó - Benzin", car_diesel: "Autó - Dízel", ... }
export type FuelTypesResponse = Record<string, string>;

export interface VehicleBrand {
	brand: string;
	label: string;
	value: string;
}

export interface VehicleModel {
	id: number;
	label: string;
	value: string;
}

export interface VehicleType {
	id: number;
	label: string;
	model: string;
	built_from: string;
	built_to: string;
	power_kw: number;
}

// The whole selector in one answer (GET /vehicle/tree): the fuel types, the brands of
// each, and the models of each brand with the id the variants are grouped under.
export interface VehicleTreeModel {
	id: number;
	label: string;
}

export interface VehicleTree {
	rev?: number;
	combined: Record<string, string>;
	brands: Record<string, string[]>;
	model_types: Record<string, Record<string, VehicleTreeModel[]>>;
}

// One brand's variants grouped by model (GET /vehicle/variants?combined=&brand=).
export interface VehicleVariant {
	id: number;
	label: string;
	path: string;
	model: string;
	built_from: number;
	built_to: number;
	power_kw: number;
}

export interface VehicleVariantGroup {
	label: string;
	items: VehicleVariant[];
}

export interface VehicleVariants {
	rev?: number;
	combined: string;
	brand: string;
	groups: Record<string, VehicleVariantGroup>;
}

export const getFuelTypes = () =>
	apiClient.get('/vehicle/fuel-types');

export const getBrands = (combined: string) =>
	apiClient.get('/vehicle/brands', { params: { combined } });

export const getModels = (combined: string, brand: string) =>
	apiClient.get('/vehicle/models', { params: { combined, brand } });

export const getTypes = (vehicleId: number) =>
	apiClient.get('/vehicle/types', { params: { vehicle_id: vehicleId } });

export const getTree = () =>
	apiClient.get('/vehicle/tree');

export const getVariants = (combined: string, brand: string) =>
	apiClient.get('/vehicle/variants', { params: { combined, brand } });

export const getBatteryList = (vehicleId: number) =>
	apiClient.get('/battery/list', { params: { vehicle_id: vehicleId } });
